<style lang="scss" scoped>
.watermark-video {
  @media (min-width: 1100px) {
    max-width: 100%;
    .markwaters {
      .scroll-form {
        flex: 1;
        height: 100%;
      }
    }
  }
}
.markwaters {
  .close-btn {
    position: fixed;
    bottom: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
  }
  .top-image-wrap {
    width: 640px;
    height: 480px;
    margin: 0 auto;
    margin-top: 10px;
    position: relative;
    img {
      display: inline-block;
      width: 100%;
      height: 100%;
    }
    .edit-wrapper {
      top: 0;
      left: 0;
      position: absolute;
      width: 100%;
      height: 100%;
      z-index: 99;
      background-color: rgba(255, 255, 255, 0.7);
    }
    .mark-item {
      position: absolute;
      background-color: rgba(#1989fa, 1);
      // opacity: 0.5;
      z-index: 111;
      .item-text {
        position: absolute;
        left: 0;
        top: 0;
      }
      &.isEdit {
        background-color: rgba(#1989fa, 0.5);
      }
    }
    .loading-wrap {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 111111;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: rgba(255, 255, 255, 0.7);
    }
  }
  .scroll-form {
    height: calc(100vh - 326px);
    overflow-y: scroll;
    .no-state {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      margin-top: 86px;
      .dashed-btn {
        padding: 0 15px;
        height: 44px;
        line-height: 44px;
        text-align: center;
        border: 1px solid dashed;
      }
    }
    .mark-form {
      .mark-num {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        padding: 10px 16px;
        height: 52px;
        line-height: 52px;
        h3 {
          font-size: 14px;
          color: #252b37;
          margin: 0;
        }
      }
      .custom-button {
        width: 26px;
        color: #fff;
        font-size: 10px;
        line-height: 18px;
        text-align: center;
        background-color: #1989fa;
        border-radius: 100px;
        margin-left: 10px;
      }
    }
  }
}
</style>
<template>
  <div class="watermark-video">
    <div class="markwaters">
      <div class="top-image-wrap">
        <canvas
          width="640px"
          height="480px"
          id="canvas"
          @click="getRGBA"
        ></canvas>
        <template v-for="(item, index) in markList">
          <div
            :class="['mark-item']"
            :key="index"
            :style="toPx(item)"
            @click="handleClickItem(item, index)"
            v-if="index !== currentIndex && !rgbTool"
          >
            <div class="item-text" v-if="item.AreaText">
              <van-tag>{{ item.AreaText }} </van-tag>
            </div>
          </div>
          <div
            class="mark-item isEdit"
            :style="toPx(currentMark)"
            ref="editBox"
            @touchstart.stop="touchStartHandle"
            @touchmove.stop="touchMoveHandle"
            @touchend.stop="touchEndHandle"
            @mousedown.stop="touchStartHandle"
            @mousemove.stop="touchMoveHandle"
            @mouseup.stop="touchEndHandle"
            :key="index"
            v-else-if="index === currentIndex && !rgbTool"
          >
            <div class="item-text" v-if="item.AreaText">
              <van-tag>{{ item.AreaText }} </van-tag>
            </div>
          </div>
        </template>
      </div>
      <div class="scroll-form">
        <template v-if="state === 'noSelected'">
          <div class="no-state">
            <span style="margin-right: 5px">请点击图片上的标注进行修改或</span>
            <van-button
              icon="plus"
              size="small"
              plain
              type="info"
              @click="handleAddMark"
              >新增标注</van-button
            >
          </div>
        </template>
        <template v-else>
          <div class="mark-form">
            <div class="mark-num">
              <template v-if="currentMark.ID">
                <h3>修改标注</h3>
                <van-button
                  size="small"
                  type="danger"
                  @click="handleArea('Remove')"
                  >删除该标注</van-button
                >
              </template>
              <h3 v-else>新增标注</h3>
            </div>
            <van-row>
              <van-col :span="24">
                <van-field
                  label-width="80px"
                  label="标注文字"
                  autosize
                  type="textarea"
                  placeholder="请输入标注文字"
                  v-model="currentMark.AreaText"
                >
                </van-field>
              </van-col>
              <van-col :span="24"
                ><van-field name="radio" label="处理动作">
                  <template #input>
                    <van-radio-group
                      v-model="currentMark.ActionType"
                      direction="horizontal"
                    >
                      <van-radio name="加水印">加水印</van-radio>
                      <van-radio name="去水印">去水印</van-radio>
                    </van-radio-group>
                  </template>
                </van-field>
              </van-col>
              <van-col :span="24"
                ><van-field
                  label-width="80px"
                  label="参数字符串"
                  type="textarea"
                  autosize
                  rows="2"
                  v-if="currentMark.ActionType == '去水印'"
                  placeholder="请添加参数字符串"
                  v-model="currentMark.ActionMethodArgs"
                >
                  <template #button>
                    <van-button
                      size="small"
                      type="primary"
                      v-if="
                        currentMark.ActionMethod == '去水印方式二' && rgbTool
                      "
                      @click="rgbTool = false"
                      >取色完成</van-button
                    >
                    <van-button
                      size="small"
                      type="primary"
                      v-if="
                        currentMark.ActionMethod == '去水印方式二' && !rgbTool
                      "
                      @click="rgbTool = true"
                      >打开取色器</van-button
                    >
                  </template>
                </van-field>
                <p
                  style="padding: 0 16px; color: #d00000"
                  v-if="rgbTool && currentMark.ActionMethod == '去水印方式二'"
                >
                  *请点击取色完成后调整水印位置
                </p>
              </van-col>
              <van-col :span="24" v-if="currentMark.ActionType == '去水印'"
                ><van-field name="radio" label="去除方式">
                  <template #input>
                    <van-radio-group
                      v-model="currentMark.ActionMethod"
                      direction="horizontal"
                    >
                      <van-radio name="去水印方式一">方式1</van-radio>
                      <van-radio name="去水印方式二">方式2</van-radio>
                      <van-radio name="去水印方式三">方式3</van-radio>
                    </van-radio-group>
                  </template>
                </van-field>
              </van-col>

              <van-col :span="24"
                ><van-field
                  label-class="f-label"
                  label-width="80px"
                  label="距左边"
                >
                  <template #button>
                    <van-stepper
                      min="0"
                      :max="boxInfo.maxX"
                      :step="0.01"
                      :decimal-length="2"
                      @change="(e) => changeStep(e, 'x')"
                      v-model.number="currentMark.LeftCoordinate"
                    />
                  </template>
                  <template #input>
                    <van-slider
                      :step="0.01"
                      :decimal-length="2"
                      :disabled="state === 'selected'"
                      v-model="currentMark.LeftCoordinate"
                      :max="boxInfo.maxX"
                    />
                  </template> </van-field
              ></van-col>
              <van-col :span="24"
                ><van-field
                  label-width="80px"
                  label="距顶部"
                  label-class="f-label"
                >
                  <template #button>
                    <van-stepper
                      min="0"
                      :step="0.01"
                      :decimal-length="2"
                      :max="boxInfo.maxY"
                      @change="(e) => changeStep(e, 'y')"
                      v-model.number="currentMark.TopCoordinate"
                    />
                  </template>
                  <template #input>
                    <van-slider
                      :step="0.01"
                      :decimal-length="2"
                      :disabled="state === 'selected'"
                      v-model="currentMark.TopCoordinate"
                      :max="boxInfo.maxY"
                    />
                  </template> </van-field
              ></van-col>
              <van-col :span="24"
                ><van-field
                  label-width="80px"
                  label="宽度"
                  label-class="f-label"
                >
                  <template #button>
                    <van-stepper
                      :min="0"
                      :step="0.01"
                      :decimal-length="2"
                      :max="boxInfo.maxWidth"
                      @change="(e) => changeStep(e, 'w')"
                      v-model.number="currentMark.Width"
                    />
                  </template>
                  <template #input>
                    <van-slider
                      :step="0.01"
                      :decimal-length="2"
                      :disabled="state === 'selected'"
                      v-model="currentMark.Width"
                      :max="boxInfo.maxWidth"
                    />
                  </template> </van-field
              ></van-col>
              <van-col :span="24"
                ><van-field
                  label-width="80px"
                  label="高度"
                  label-class="f-label"
                >
                  <template #button>
                    <van-stepper
                      min="0"
                      @change="(e) => changeStep(e, 'h')"
                      :step="0.01"
                      :decimal-length="2"
                      :max="boxInfo.maxHeight"
                      v-model.number="currentMark.Height"
                    />
                  </template>
                  <template #input>
                    <van-slider
                      :step="0.01"
                      :decimal-length="2"
                      :disabled="state === 'selected'"
                      v-model="currentMark.Height"
                      :max="boxInfo.maxHeight"
                    />
                  </template> </van-field
              ></van-col>
            </van-row>
            <van-row style="margin: 10px 0" :gutter="10">
              <template v-if="state === 'edit'">
                <van-col :span="8" :offset="4"
                  ><van-button
                    size="small"
                    @click="cancelAddOrEdit(true)"
                    block
                    plain
                    type="info"
                    >取消</van-button
                  ></van-col
                >
                <van-col :span="8"
                  ><van-button
                    size="small"
                    block
                    type="info"
                    @click="handleArea('Update')"
                    >确认修改</van-button
                  ></van-col
                >
              </template>

              <template v-else>
                <van-col :span="8" :offset="4"
                  ><van-button
                    size="small"
                    type="info"
                    @click="cancelAddOrEdit(false)"
                    plain
                    block
                    >取消</van-button
                  ></van-col
                >
                <van-col :span="8"
                  ><van-button
                    block
                    size="small"
                    type="info"
                    @click="handleArea('Update')"
                    >确认新增</van-button
                  ></van-col
                >
              </template>
            </van-row>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import _ from "lodash";
export default {
  name:'watermark',
  data() {
    return {
      rgbTool: false,
      target: {},
      //展示状态  noSelected 默认    add  新增    edit  修改
      state: "noSelected",
      loading: true,
      isEdit: false,
      isAdd: false,
      currentIndex: -1,
      startPoint: { dx: "", dy: "" },
      endPoint: { dx: "", dy: "", x: "", y: "" },
      currentMark: {
        Width: 0.3,
        Height: 0.3,
        LeftCoordinate: 0,
        TopCoordinate: 0,
        rgb: "",
        AreaText: "",
        ActionMethodArgs: "",
        ActionMethod: "去水印方式一",
        ActionType: "加水印",
      },
      markList: [],
      r_markList: [],
      inDrag: false,
      rgb: "",
    };
  },
  computed: {
    boxInfo() {
      return {
        maxX: 1 - this.currentMark.Width,
        maxY: 1 - this.currentMark.Height,
        maxWidth: 1 - this.currentMark.LeftCoordinate,
        maxHeight: 1 - this.currentMark.TopCoordinate,
      };
    },
  },
  mounted() {
    this.getAreaList();
  },
  methods: {
    formatter(value) {
      return value + " " + this.rgb;
    },
    changeAreaText(e, t) {},
    initCanvas() {
      const self = this;
      let canvas = document.getElementById("canvas");
      let ctx = canvas.getContext("2d");
      let image = new Image();
    //   image.src = this.target.ScreenshotFilePath;
      image.src = require("../assets/img/abt.jpg");
      image.onload = function () {
        ctx.drawImage(image, 0, 0, 640, 480);
        self.ctx = ctx;
      };
    },
    getRGBA(e) {
      if (this.currentMark.ActionMethod == "去水印方式二" && this.rgbTool) {
        let point = {};
        if (e.pageX && e.pageY) {
          point.x = e.pageX;
          point.y = e.pageY - 55;
        } else {
          point.x = e.clientX;
          point.y = e.clientY - 55;
        }
        let imgData = this.ctx.getImageData(point.x, point.y, 640, 480);
        let r = imgData.data[0];
        let g = imgData.data[1];
        let b = imgData.data[2];
        let a = imgData.data[3];
        this.currentMark.ActionMethodArgs =
          this.currentMark.ActionMethodArgs + `"${r},${g},${b}" `;
      }
      return;
    },
    goBack() {
      this.$router.back();
    },
    changeStep(e, type) {
      if (type === "w") {
        if (e === "" || e > this.boxInfo.maxWidth) {
          this.currentMark.Width = 0;
        }
      }
      if (type === "h") {
        if (e === "" || e > this.boxInfo.maxHeight) {
          this.currentMark.Height = 0;
        }
      }
      if (type === "x") {
        if (e === "" || e > this.boxInfo.maxX) {
          this.currentMark.LeftCoordinate = 0;
        }
      }
      if (type === "y") {
        if (e === "" || e > this.boxInfo.maxY) {
          this.currentMark.TopCoordinate = 0;
        }
      }
    },
    //获取所有标注列表
    getAreaList() {
      this.resetCurrentMark();
      this.loading = true;
      this.markList = [];
      this.r_markList = _.cloneDeep([]);
      this.loading = false;
      this.$nextTick(() => {
        this.initCanvas();
      });
    },
    //标注样式
    toPx(v) {
      let obj = {};
      obj["left"] = 640 * v["LeftCoordinate"] + "px";
      obj["top"] = 480 * v["TopCoordinate"] + "px";
      obj["width"] = 640 * v["Width"] + "px";
      obj["height"] = 480 * v["Height"] + "px";
      return obj;
    },
    //重置当前编辑数据
    resetCurrentMark() {
      this.currentMark = {
        Width: 0.3,
        Height: 0.3,
        LeftCoordinate: 0,
        TopCoordinate: 0,
        rgb: "",
        AreaText: "",
        ActionMethodArgs: "",
        ActionMethod: "去水印方式三",
        ActionType: "去水印",
      };
      this.currentIndex = -1;
      this.state = "noSelected";
    },
    //点击新增按钮
    handleAddMark() {
      this.resetCurrentMark();
      this.state = "add";
      this.markList.push(this.currentMark);
      this.currentIndex = this.markList.length - 1;
    },
    //取消新增/编辑
    cancelAddOrEdit(edit) {
      this.state = "noSelected";
      this.resetCurrentMark();
      if (!edit) {
        this.markList.pop();
      }
    },
    //点击标注区域
    handleClickItem(item, index) {
      if (this.state === "add") {
        this.markList.pop();
      }
      this.state = "edit";
      this.currentIndex = index;
      this.currentMark = _.cloneDeep(item);
    },
    //提交新增/修改/删除
    async handleArea(type = "Update") {
      const self = this;
      if (type == "Update") {
        function isEqual() {
          return self.r_markList.some(
            (item) =>
              item.Width == self.currentMark.Width &&
              item.Height == self.currentMark.Height &&
              item.TopCoordinate == self.currentMark.TopCoordinate &&
              item.LeftCoordinate == self.currentMark.LeftCoordinate
          );
        }
        debugger
        if (isEqual()) {
          this.$toast("该水印已存在，请重新调整水印大小或位置");
          return;
        }
        if (!this.currentMark.Width) {
          this.$toast("请输入标注宽度");
          return;
        }
        if (!this.currentMark.Height) {
          this.$toast("请输入标注高度");
          return;
        }
      }

      let svc = this.$http("VCA", `VCA.AreaMngmt_${type}`);
      svc.AddParam({
        Name: "area_id",
        Value: this.currentMark.ID ? this.currentMark.ID : 0,
        DBType: "bigint",
      });
      if (type === "Update") {
        let areaInfo = {
          VideoClipID: this.currentMark.VideoClipID
            ? this.currentMark.VideoClipID
            : this.id,
          Width: this.currentMark.Width,
          Height: this.currentMark.Height,
          AreaText: this.currentMark.AreaText,
          LeftCoordinate: this.currentMark.LeftCoordinate,
          TopCoordinate: this.currentMark.TopCoordinate,
          StartTime: this.currentMark.StartTime
            ? this.currentMark.StartTime
            : this.target.StartTime,
          EndTime: this.currentMark.EndTime
            ? this.currentMark.EndTime
            : this.target.EndTime,
          ActionType: this.currentMark.ActionType,
        };
        if (this.currentMark.ActionType === "去水印") {
          areaInfo.ActionMethod = this.currentMark.ActionMethod;
          areaInfo.ActionMethodArgs = this.currentMark.ActionMethodArgs;
        }
        svc.AddParam({
          Name: "area_info",
          Value: JSON.stringify(areaInfo),
          DBType: "string",
        });
        svc.AddParam({
          Name: "fake_user_id",
          Value: this.$store.state.user.userId,
          DBType: "string",
        });
      }
      let res = await svc.ExecTable();
      if (res) {
        this.$toast("操作成功");
        this.getAreaList();
      } else {
        this.$toast("操作失败");
      }
    },
    touchStartHandle(e) {
      let ele;
      if (e.targetTouches) {
        ele = e.targetTouches[0];
      } else {
        ele = e;
      }

      this.startPoint = {
        dx: ele.clientX - this.$refs.editBox[0].offsetLeft,
        dy: ele.clientY - this.$refs.editBox[0].offsetTop,
      };
      this.inDrag = true;
    },
    touchMoveHandle(e) {
      e.preventDefault();
      if (this.inDrag) {
        let maxX = 1 - this.currentMark.Width;
        let maxY = 1 - this.currentMark.Height;
        let ele;
        if (e.targetTouches) {
          ele = e.targetTouches[0];
        } else {
          ele = e;
        }
        let x = ele.clientX - this.startPoint.dx;
        let y = ele.clientY - this.startPoint.dy;
        // if (
        //   Number(x) < 0 ||
        //   Number(y) < 0 ||
        //   y > maxY * 480 ||
        //   x > maxX * 640
        // ) {
        //   this.inDrag = false;
        //   return;
        // } else {
        //   this.inDrag = true;
        // }
        x = x <= 0 ? 0 : x >= maxX * 640 ? maxX * 640 : x;
        y = y <= 0 ? 0 : y >= maxY * 480 ? maxY * 480 : y;
        // console.log(x)

        // x=y;
        // y=y;
        this.$refs.editBox[0].style.left = x + "px";
        this.$refs.editBox[0].style.top = y + "px";
        this.lastPoint = {
          x: x,
          y: y,
          dx: ele.clientX - 640 * this.currentMark.LeftCoordinate,
          dy: ele.clientY - 480 * this.currentMark.TopCoordinate,
        };
      }
    },
    touchEndHandle() {
      if (this.inDrag) {
        this.startPoint.dx = this.lastPoint.dx;
        this.startPoint.dy = this.lastPoint.dy;
        this.currentMark.LeftCoordinate = this.lastPoint.x / 640;
        this.currentMark.TopCoordinate = this.lastPoint.y / 480;
        this.inDrag = false;
      }
    },
  },
};
</script>